
import InvoicesTransactionHistoryItem from "./invoices-transaction-history-item.vue";

export default {
  components: {
    InvoicesTransactionHistoryItem
  },
  props: {
    transactionHistoryData: {
      default: () => [],
      type: Array
    }
  }
};
